export default {
      id: "icon--search-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "./../Views/Shared/_SvgSprite.cshtml#icon--search",
      toString: function () {
        return this.url;
      }
    }